export default __webpack_public_path__ + "static/media/bear.7ef01a4d.png";